"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var dialog_1 = require("spry-react/Dialog/dialog");
function ErrorDialog(props) {
    return React.createElement(dialog_1.SimpleDialog, { singleTabText: props.singleTabText, close: props.close },
        React.createElement("div", { className: "server-error-details" },
            React.createElement("h2", { className: "server-error-icon cancel-icon large-icon-5rem error l-box-vt-1-4x" }),
            React.createElement("div", { className: "server-error-description l-box-vt" }, props.children)));
}
exports.ErrorDialog = ErrorDialog;
